import {createRootRouteWithContext} from '@tanstack/react-router';
import type {RouterContext} from '@/app/router-context';
import {RootErrorBoundary, RootNotFound} from '@/app/shell/root-error-boundary';
import {RootLayout} from '@/app/shell/root-layout';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  errorComponent: RootErrorBoundary,
  notFoundComponent: RootNotFound,
});
